import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpService from "../../services/httpService";
import { notify } from "../utils/methods/notification";


const initialState = {
    isLoading: false,
    allCountries: [],
    addModal: false,

};
export const fetchAllCountry = createAsyncThunk(
    'bmr/fetchAllCountry',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getAllCountries', { params: payload });
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const addCountry = createAsyncThunk(
    'bmr/addCountry',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await httpService.post('/addcountry', args);
            notify.success(response?.data?.message || response?.message || "Country added successfully");
            dispatch(disableAddModal());
            dispatch(fetchAllCountry());
            return response.data;
        } catch (error) {
             notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const deleteCountry = createAsyncThunk(
    'bmr/deleteCountry',
    async (args, { rejectWithValue }) => {
        try {
            const { id } = args;
            const response = await httpService.delete(`/deletecountry/${id}`);
            notify.success(response?.data?.message || "Country deleted successfully");
            return response.data;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            notify.error(message);
            return rejectWithValue(message);
        }
    }
);

export const updateCountry= createAsyncThunk(
    'country/updateCountry',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { editId, data } = args;
            const response = await httpService.put(`/updatecountry/${editId}`, data);
            notify.success(response?.data?.message || response?.message || "Country updated successfully");
                dispatch(disableAddModal());
            dispatch(fetchAllCountry());
            return response.data;
        } catch (error) {
            notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const bmrCountrySlice = createSlice({
    name: 'bmrCountry',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllCountry.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allCountries=action.payload
            })
            .addCase(fetchAllCountry.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteCountry.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteCountry.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(updateCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateCountry.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.currentCountry?.id === action.payload.id) {
                    state.currentCountry = action.payload;
                }
            })
            .addCase(updateCountry.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(addCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addCountry.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addCountry.rejected, (state) => {
                state.isLoading = false;
            })
    }
})
export const { enableAddModal, disableAddModal } = bmrCountrySlice.actions;
export default bmrCountrySlice.reducer;